import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface TMasterEnrollmentSubgroup {
  name: string
  status: string
  subgroupId: number
}

export interface TMissingDocument {
  questionId: number
  label: string
  formId: number
}

// A file on the enrollment, for the card (DTA-998). Received = the school has it;
// unsubmitted = uploaded into a form the family has not submitted yet.
export interface TEnrollmentDocument {
  questionId: number
  formId: number
  label: string
  filename: string
  uploadedAt: string | null
}

export interface TMasterEnrollment {
  masterEnrollmentId: number
  studentAccountId: number
  familyUserId: number
  districtId: number
  studentName: string | null
  programYear: string | null
  formGroupId: number | null
  formGroupName: string | null
  formNames: string[]
  formSubmissionId: string | null
  missingDocuments: TMissingDocument[]
  heldForDocuments: boolean
  receivedDocuments?: TEnrollmentDocument[]
  unsubmittedDocuments?: TEnrollmentDocument[]
  submissionStatus: string
  isPast: boolean
  subgroups: TMasterEnrollmentSubgroup[]
}

// GET /ajax/enrollment/master-enrollments — the logged-in family's master
// enrollments for the enrollment dashboard (SOW-183).
export const masterEnrollments = async (): Promise<TMasterEnrollment[]> => {
  const response = await new Request().get('/ajax/enrollment/master-enrollments')
  return Util.Obj.keysToCamel(response.data.items) as TMasterEnrollment[]
}
